import axios from 'axios';

const api = axios.create({
  baseURL: 'https://mapeiasaber.tech/node/api'
    // baseURL: 'http://localhost:3001/api/'
});

export default api;